"use strict";

// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var _regeneratorRuntime = require("G:\\__main\\_work\\_projects\\Cinemex\\cinemex-2018-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");
var __asyncValues = this && this.__asyncValues || function (o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator],
    i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i);
  function verb(n) {
    i[n] = o[n] && function (v) {
      return new Promise(function (resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }
  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function (v) {
      resolve({
        value: v,
        done: d
      });
    }, reject);
  }
};
var __await = this && this.__await || function (v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
};
var __asyncGenerator = this && this.__asyncGenerator || function (thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []),
    i,
    q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () {
    return this;
  }, i;
  function awaitReturn(f) {
    return function (v) {
      return Promise.resolve(v).then(f, reject);
    };
  }
  function verb(n, f) {
    if (g[n]) {
      i[n] = function (v) {
        return new Promise(function (a, b) {
          q.push([n, v, a, b]) > 1 || resume(n, v);
        });
      };
      if (f) i[n] = f(i[n]);
    }
  }
  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle(q[0][3], e);
    }
  }
  function step(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }
  function fulfill(value) {
    resume("next", value);
  }
  function reject(value) {
    resume("throw", value);
  }
  function settle(f, v) {
    if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizeDelimitedEncode = sizeDelimitedEncode;
exports.sizeDelimitedDecodeStream = sizeDelimitedDecodeStream;
exports.sizeDelimitedPeek = sizeDelimitedPeek;
var to_binary_js_1 = require("../to-binary.js");
var binary_encoding_js_1 = require("./binary-encoding.js");
var from_binary_js_1 = require("../from-binary.js");
/**
 * Serialize a message, prefixing it with its size.
 *
 * A size-delimited message is a varint size in bytes, followed by exactly
 * that many bytes of a message serialized with the binary format.
 *
 * This size-delimited format is compatible with other implementations.
 * For details, see https://github.com/protocolbuffers/protobuf/issues/10229
 */
function sizeDelimitedEncode(messageDesc, message, options) {
  var writer = new binary_encoding_js_1.BinaryWriter();
  writer.bytes((0, to_binary_js_1.toBinary)(messageDesc, message, options));
  return writer.finish();
}
/**
 * Parse a stream of size-delimited messages.
 *
 * A size-delimited message is a varint size in bytes, followed by exactly
 * that many bytes of a message serialized with the binary format.
 *
 * This size-delimited format is compatible with other implementations.
 * For details, see https://github.com/protocolbuffers/protobuf/issues/10229
 */
function sizeDelimitedDecodeStream(messageDesc, iterable, options) {
  return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function sizeDelimitedDecodeStream_1() {
    var _a, e_1, _b, _c, append, buffer, _d, iterable_1, iterable_1_1, chunk, size;
    return _regeneratorRuntime.wrap(function sizeDelimitedDecodeStream_1$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            append = function _append(buffer, chunk) {
              var n = new Uint8Array(buffer.byteLength + chunk.byteLength);
              n.set(buffer);
              n.set(chunk, buffer.length);
              return n;
            }; // append chunk to buffer, returning updated buffer
            buffer = new Uint8Array(0);
            _context.prev = 2;
            _d = true, iterable_1 = __asyncValues(iterable);
          case 4:
            _context.next = 6;
            return __await(iterable_1.next());
          case 6:
            iterable_1_1 = _context.sent;
            _a = iterable_1_1.done;
            if (_a) {
              _context.next = 28;
              break;
            }
            _c = iterable_1_1.value;
            _d = false;
            chunk = _c;
            buffer = append(buffer, chunk);
          case 13:
            size = sizeDelimitedPeek(buffer);
            if (!size.eof) {
              _context.next = 16;
              break;
            }
            return _context.abrupt("break", 25);
          case 16:
            if (!(size.offset + size.size > buffer.byteLength)) {
              _context.next = 18;
              break;
            }
            return _context.abrupt("break", 25);
          case 18:
            _context.next = 20;
            return __await((0, from_binary_js_1.fromBinary)(messageDesc, buffer.subarray(size.offset, size.offset + size.size), options));
          case 20:
            _context.next = 22;
            return _context.sent;
          case 22:
            buffer = buffer.subarray(size.offset + size.size);
          case 23:
            _context.next = 13;
            break;
          case 25:
            _d = true;
            _context.next = 4;
            break;
          case 28:
            _context.next = 33;
            break;
          case 30:
            _context.prev = 30;
            _context.t0 = _context["catch"](2);
            e_1 = {
              error: _context.t0
            };
          case 33:
            _context.prev = 33;
            _context.prev = 34;
            if (!(!_d && !_a && (_b = iterable_1.return))) {
              _context.next = 38;
              break;
            }
            _context.next = 38;
            return __await(_b.call(iterable_1));
          case 38:
            _context.prev = 38;
            if (!e_1) {
              _context.next = 41;
              break;
            }
            throw e_1.error;
          case 41:
            return _context.finish(38);
          case 42:
            return _context.finish(33);
          case 43:
            if (!(buffer.byteLength > 0)) {
              _context.next = 45;
              break;
            }
            throw new Error("incomplete data");
          case 45:
          case "end":
            return _context.stop();
        }
      }
    }, sizeDelimitedDecodeStream_1, null, [[2, 30, 33, 43], [34,, 38, 42]]);
  }));
}
/**
 * Decodes the size from the given size-delimited message, which may be
 * incomplete.
 *
 * Returns an object with the following properties:
 * - size: The size of the delimited message in bytes
 * - offset: The offset in the given byte array where the message starts
 * - eof: true
 *
 * If the size-delimited data does not include all bytes of the varint size,
 * the following object is returned:
 * - size: null
 * - offset: null
 * - eof: false
 *
 * This function can be used to implement parsing of size-delimited messages
 * from a stream.
 */
function sizeDelimitedPeek(data) {
  var sizeEof = {
    eof: true,
    size: null,
    offset: null
  };
  for (var i = 0; i < 10; i++) {
    if (i > data.byteLength) {
      return sizeEof;
    }
    if ((data[i] & 0x80) == 0) {
      var reader = new binary_encoding_js_1.BinaryReader(data);
      var size = void 0;
      try {
        size = reader.uint32();
      } catch (e) {
        if (e instanceof RangeError) {
          return sizeEof;
        }
        throw e;
      }
      return {
        eof: false,
        size: size,
        offset: reader.pos
      };
    }
  }
  throw new Error("invalid varint");
}